module.exports = __webpack_public_path__ + "img/proveemos-asistencia-especialidades.46231941.jpg";